import { render, staticRenderFns } from "./Reboquista.vue?vue&type=template&id=84425056&"
import script from "./Reboquista.vue?vue&type=script&lang=js&"
export * from "./Reboquista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports